import { confirm } from '@src/components/confirm-tips/index';

const checkSafeUrl = (url) => {
  let domain = ''
  try {
    const urlInfo = new URL(url);
    domain = urlInfo.hostname
  } catch (error) {
    domain = url
  }
  
  // 判断是否是华为域名，需要去hostname字段，而不是整个url，例如url中携带@字符，域名是@后的内容
  return !url || !url.startsWith('http') || url.startsWith('h5://') || domain.includes('huawei.com') || domain.includes('huaweicloud.com')
}

// 拦截open事件
export const changeOpen = () => {
  const oldOpen = window.open;
  window.open = (url, target, features) => {
    const isSafeUrl = checkSafeUrl(url)
    if (isSafeUrl) {
      return oldOpen(url, target, features);
    } else {
      confirm({
        content:'该操作将跳转到外部链接，是否继续？',
        cancelText: '取消',
        okText: '确定',
      }).then(res => {
        if (res) {
          return oldOpen(url, target, features);
        }
      });
    }
  }
}


//拦截所有a标签跳转事件
export const registerALabelClick = () => {

    const links = document.querySelectorAll('a');
    links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.startsWith('http') && !(href.includes('huawei.com') || href.includes('huaweicloud.com'))) {
      link.addEventListener('click', (event) => {
        // 阻止默认行为，即阻止跳转
        event.preventDefault();
        const target = link.getAttribute('target');
        window.open(href, target);
      });
    }

  });
}
